import * as yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { HTTP_ENDPOINTS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  categoryId: yup.number().required(),
  serviceIds: yup.array().of(yup.number()).required(),
});

export function useUpdateServicesObOrderMutation(options = {}) {
  return useMutation((dto) => {
    const req = requestSchema.validateSync(dto, {
      strict: true,
    });
    return http.post(HTTP_ENDPOINTS.updateServicesObOrder(), {
      category_id: req.categoryId,
      ids: req.serviceIds,
    });
  }, options);
}
